import React, { Fragment} from 'react';

import Header from '../../Dashboard/Header';
import UserUpdateForm from './UserUpdateForm';


function UserUpdateComponent (props: any) {

  const { client, user, onSubmit } = props;

  return (
    <Fragment>
      <Header title="MODIFICAR UN CLIENTE"/>
      <div className="row">
        <div className="col col-lg-12 col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="main-content-label mg-b-5">Modificación del cliente</div>
              <div className="row">
              <div className="mx-auto d-block col-xl-6 col-lg-8 col-md-10">
                <div className="card pd-20 pd-md-40 card-body">
                  <h5 className="card-title mg-b-20 fs-6">Modifica un cliente</h5>
                  <UserUpdateForm onSubmit={onSubmit} client={client} user={user}/>
                </div>
              </div>
            </div>  
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};


export default UserUpdateComponent;
